<template>
  <v-app>
    <router-view>
    </router-view>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div>
              <strong>{{ snackbar.title }}</strong>
            </div>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>clear</v-icon>
        </v-btn>
    </v-snackbar>
    <div class="cookie-bar" v-if="languageData.cookies && !isCookiesAccepted">
      <div class="cookie-content-wrapper">
        {{ languageData.cookies.newTextInfo + ' '}}
        <a style="color: #fff; font-weight: 600" href="https://support.einklick.net/knowledgebase/datenschutzerklärung">{{ languageData.cookies.dataProtectionDeclarationLink }}</a>
      </div>
      <div class="cookie-btn-wrapper">
        <v-btn
          color="#fff"
          outlined
          class="mr-5"
          @click="openManageCookiesModal"
          style="color: #fff; letter-spacing: 2px"
        >
          {{ languageData.cookies.manageBtn }}
        </v-btn>
        <v-btn
          color="#fff"
          style="color: #FFA400; letter-spacing: 2px"
          @click="acceptAllCookies"
        >
          {{ languageData.cookies.acceptBtn }}
        </v-btn>
      </div>
    </div>
    <ModalInfo v-if="languageData.cookies" :hidden-agree-btn="true" :show-modal="ManageCookiesModalIsVisible" @clicked="hideManageCookiesModal" :headModal="languageData.cookies.manageModalHead" :text-modal="languageData.cookies.newManageModalTextInfo">
      <template v-slot:body class="px-5">
        <v-row>
          <v-radio-group v-model="cookiesRadioGroup" required>
            <v-col cols="12" style="margin-top: 0 !important; padding-top: 0 !important">
              <v-radio value="essential">
                <template v-slot:label>
                  <p class="cookie-radio-label">{{ languageData.cookies.manageModalAcceptEssential }}</p>
                </template>
              </v-radio>
            </v-col>
            <v-col cols="12">
              <v-radio value="all">
                <template v-slot:label>
                  <p class="cookie-radio-label">{{ languageData.cookies.manageModalAcceptAll }}</p>
                </template>
              </v-radio>
            </v-col>
          </v-radio-group>
        </v-row>
        <v-row justify="end">
          <v-btn
            color="primary"
            height="40px"
            style="padding-left: 20px; padding-right: 20px"
            @click="saveManageCookies"
            >
          {{ languageData.cookies.manageModalSaveBtn }}
          </v-btn>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo v-if="isModalVisible" :isLoadingBtn="false" @doOperation="handleLeaveBtn" :btnAgreeText="languageData.btnLeave" :btnDisAgreeText="languageData.btnStay" :visDisAgreeBtn="true" :show-modal="isModalVisible" @clicked="hideModal" :headModal="languageData.attentionHead" :text-modal="languageData.dataLostText">
    </ModalInfo>
    <ModalInfo :btnAgreeText="'OK'" :show-modal="isVisibleIncompleteProfileModal" @clicked="hideIncompleteProfileModal" :headModal="languageData.incompleteProfileWarningHead" :text-modal="languageData.incompleteProfileWarningText"></ModalInfo>
    <ModalInfo v-if="languageData.emailForm" :hidden-agree-btn="true" :layout="'modalForm'" @clicked="hideEmailFormModal" :show-modal="isEmailFormVisible">
      <template v-slot:header>
        {{ languageData.emailForm[documentTypeToSend]}}
      </template>
      <template v-slot:body>
        <EmailForm></EmailForm>
      </template>
    </ModalInfo>
  </v-app>
</template>


<script>
  import Vue from "vue";
  import {mapActions, mapState} from "vuex";
  import config from "./config";
  import ModalInfo from "../main/components/ModalInfo/ModalInfo.vue";
  import EmailForm from "./components/EmailForm/EmailForm.vue";
  import router from "../router";

  Vue.mixin({
    components: { ModalInfo, EmailForm },
    data() {
      return {
        ManageCookiesModalIsVisible: false,
        isCookiesAccepted: false,
        cookiesRadioGroup: null,
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          corner: 'right',
          timeout: 7500,
          title: null,
          visible: false
        },
      }
    },
    computed: {
      ...mapState('languageMain', {
        languageData: state => state.languageData,
        language: state => state.language,
        activeCountry: state => state.activeCountry
      }),
      ...mapState('preventDataLost', {
        isDataChanged: state => state.isDataChanged,
        isModalVisible: state => state.isModalVisible,
        currentPath: state => state.currentPath
      }),
      ...mapState('incompleteProfile', {
        isVisibleIncompleteProfileModal: state => state.isVisibleIncompleteProfileModal,
      }),
      ...mapState('manageEmailForm', {
        isEmailFormVisible: state => state.isEmailFormVisible,
        documentTypeToSend: state => state.documentType,
      }),
      getCurrentLanguage: function() {
        return localStorage.getItem("language") || config.defaultLanguage;
      },
      getCurrentCountry() {
        return localStorage.getItem("country") || config.defaultCountry;
      },
      getToken: function() {
        return localStorage.getItem("tokenAuth");
      },
    },
    methods: {
      ...mapActions('languageMain', ['updateLanguageTemplate', "updateCountry"]),
      ...mapActions("getSubscription", ["getSubscriptionData"]),
      ...mapActions('preventDataLost', ["updateDataInFormIsChanged", "updateIsModalVisible"]),
      ...mapActions("incompleteProfile", ["updateIsIncompleteProfileModallVisible"]),
      ...mapActions("manageEmailForm", ["updateIsEmailFormVisible"]),

      hideEmailFormModal() {
        switch (this.documentTypeToSend) {
          case 'offer':
            if (router.currentRoute.name !== 'OffersList') {
              router.push({ path:"/offers" });
            }  
            break;
          default:
            null
        }
        this.updateIsEmailFormVisible(false);
      },

      updateLanguage(value) {
        var route = this.$route.path.split('/')[1];
        var creds = {
          language: value,
          template: route,
        };
        if(this.getToken) {
          this.getSubscriptionData();
        }
        this.updateLanguageTemplate(creds);
      },
      updateCountryFlag(country) {
        this.updateCountry(country);
      },
      hideModal() {
        this.updateDataInFormIsChanged(false);
        this.updateIsModalVisible(false)
      },
      handleStayBtn() {
        this.updateIsModalVisible(false)
      },
      handleLeaveBtn() {
        this.updateDataInFormIsChanged(false);
        this.updateIsModalVisible(false)
        this.$router.push(this.currentPath)
      },
      hideIncompleteProfileModal() {
        this.updateIsIncompleteProfileModallVisible(false);
      },
      openManageCookiesModal() {
        this.ManageCookiesModalIsVisible = true;
      },
      hideManageCookiesModal() {
        this.ManageCookiesModalIsVisible = false;
      },
      acceptAllCookies() {
        this.$cookies.set('einKlick', 'all', 60 * 60 * 24 * 365 * 10, '/', 'einklick.net');
        this.isCookiesAccepted = true;
        this.getSnackbar('Success', this.languageData.cookies.saveCookiesSuccessInfo, "success", "check_circle");
      },
      saveManageCookies() {
        if (this.cookiesRadioGroup) {
          this.$cookies.set('einKlick', this.cookiesRadioGroup, 60 * 60 * 24 * 365 * 10, '/', 'einklick.net');
          this.ManageCookiesModalIsVisible = false;
          this.isCookiesAccepted = true;
          this.getSnackbar('Success', this.languageData.cookies.saveCookiesSuccessInfo, "success", "check_circle");
        } else {
          this.getSnackbar('Error', this.languageData.cookies.manageCookiesErrorText, "error", "error");
        }
      },
      getSnackbar: function(title, message, color, icon) {
        this.snackbar = {
          color: color,
          icon: icon,
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },
    },
    mounted() {
      if(localStorage.getItem("companyName") === null && localStorage.getItem("companyFirstName") === null && localStorage.getItem("companyLastName") === null) {
        localStorage.setItem("companyName", "");
        localStorage.setItem("companyFirstName", "");
        localStorage.setItem("companyLastName", "");
      }
      if (this.$cookies.get('einKlick') === 'all' || this.$cookies.get('einKlick') === 'essential') {
        this.isCookiesAccepted = true;
      } else {
        this.isCookiesAccepted = false;
      }
    },
  });


  export default {
    name: "Main"
  }
</script>

<style src="./Main.scss" lang="scss"></style>